import { useState, useContext, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Drivers/DriverMyRides/DriverMyRides.css';
import DriverMasterLayout from '../../../layouts/Drivers/DriverMasterLayout';
import RideCard from '../../../components/Drivers/Rides/RideCard';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const DriverMyRides = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken, setSelectedRideforFindingDriver } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState('accept');
  const [rides, setRides] = useState([]);

  const fetchRides = (status) => {
    const formData = new FormData();
    formData.append("status", status);

    axios.post(`${baseUrl}/driver/ride/viewMyRides`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((response) => {
      if (response.data.success === true) {
        setRides(response.data.rides);
      }
    }).catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchRides("accept");
  }, []);

  const handleRideClick = (ride) => {
    const formData = new FormData();
    formData.append("tdride_id", ride.id);

    axios.post(`${baseUrl}/driver/ride/pickupCustomer`, formData, {
        headers: { 
          Authorization: `Bearer ${authToken}` 
      }
    }).then((response) => {
        if (response.data.success === true) {
          setSelectedRideforFindingDriver(ride); 
            navigate('/pickup-customer');
        }
    }).catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
};

  const handleCompletedride = (ride) => {
    navigate('/ride-completed');
  };

  const tabs = [
    { key: 'accept', label: 'Accept Ride' },
    { key: 'ongoing', label: 'Ongoing Ride' },
    { key: 'pending', label: 'Pending Ride' },
    { key: 'complete', label: 'Complete Ride' },
    { key: 'cancel', label: 'Cancel Ride' },
  ];

  const emptyMessages = {
    accept: { icon: '🚗', title: 'No Accepted Rides', text: 'Accepted rides will appear here' },
    ongoing: { icon: '📋', title: 'No ongoing Rides', text: 'Ongoing rides will appear here' },
    pending: { icon: '📋', title: 'No Pending Rides', text: 'Pending rides will appear here' },
    complete: { icon: '✓', title: 'No Completed Rides', text: 'Completed rides will appear here' },
    cancel: { icon: '✕', title: 'No Cancelled Rides', text: 'Cancelled rides will appear here' },
  };

  return (
    <DriverMasterLayout screenName={"MyRides"} centered={true}>
      <div className="driver-myrides-container">

        {/* Tabs */}
        <div className="driver-myrides-tabs-wrapper">
          <Container>
            <div className="driver-myrides-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`driver-myrides-tab ${activeTab === tab.key ? 'driver-myrides-tab-active' : ''}`}
                  onClick={() => {
                    setActiveTab(tab.key);
                    fetchRides(tab.key);
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </Container>
        </div>

        {/* Content */}
        <div className="driver-myrides-content">
          <Container className="driver-myrides-wrapper">
            <div className="driver-myrides-list">
              {rides.length > 0 ? (
                rides.map((ride, index) => (
                  <RideCard
                    key={index}
                    ride={ride}
                    showPickupButton={activeTab === 'accept'}
                    showActionButtons={activeTab === 'accept'}
                    onClick={() => activeTab === 'complete' ? handleCompletedride(ride) : handleRideClick(ride)}
                  />
                ))
              ) : (
                <div className="driver-myrides-empty-state">
                  <div className="driver-myrides-empty-icon">{emptyMessages[activeTab]?.icon}</div>
                  <h5 className="driver-myrides-empty-title">{emptyMessages[activeTab]?.title}</h5>
                  <p className="driver-myrides-empty-text">{emptyMessages[activeTab]?.text}</p>
                </div>
              )}
            </div>
          </Container>
        </div>

      </div>
    </DriverMasterLayout>
  );
};

export default DriverMyRides;